// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3cA_h","inputWrap":"CustomTip_inputWrap__2DzcW"};